// src/persist/sessionAutosaveListener.js
// pgw 27-jan-2026

import { createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit";

// pwg 28-jan-2026
// import { saveExistingSession } from "../features/setlist/setlistSlice";
import { saveLibrarySongSettings } from "../features/songSettings/songSettingsSlice";
import { updateSetlistItemSettings } from "../features/setlists/setlistsSlice";

import {
  changeChannelGain,

  muteChannel,
  unmuteChannel,

  soloChannel,
  unsoloChannel,

  changeChannelPan,

  increaseGlobalPlaybackRate,
  decreaseGlobalPlaybackRate,
  changeGlobalPlaybackRate,

  increaseGlobalPitchRate,
  decreaseGlobalPitchRate,
  changeGlobalPitch,


  // add other "song settings changed" actions here
} from "../features/session/sessionSlice";



export const sessionAutosaveListener = createListenerMiddleware();

let flushTimer;


sessionAutosaveListener.startListening({
  matcher: isAnyOf(
    changeChannelGain,

    muteChannel,
    unmuteChannel,

    soloChannel,
    unsoloChannel,

    changeChannelPan,

    increaseGlobalPlaybackRate,
    decreaseGlobalPlaybackRate,
    changeGlobalPlaybackRate,

    increaseGlobalPitchRate,
    decreaseGlobalPitchRate,
    changeGlobalPitch,


    // add more actions that mutate session settings
  ),
  effect: async (action, listenerApi) => {


	console.log("[AUTOSAVE] action", action.type);

	// Never respond to our own saving / persist machinery
	if (
		action.type === "setlist/saveExistingSession" ||
		action.type === "songSettings/saveLibrarySongSettings" ||
		action.type === "setlists/updateSetlistItemSettings" ||
		action.type === "persist/FLUSH" ||
		action.type.startsWith("persist/")
	) {
		console.log("[AUTOSAVE] - returning to avoid race condition");
		return;
	}

    const state = listenerApi.getState();

    const session = state.session; // assumes your current session slice contains id/song/stems/etc

	if (!session?.id || session.status !== "ready") {
		console.log("[AUTOSAVE] - session?.id = ", session?.id);
		console.log("[AUTOSAVE] - session.status = ", session.status);
		console.log("[AUTOSAVE] - returning because session?.id not defined or status is not ready ");
		return;
	}


	console.log("[PERSIST_SESSIONAUTOSAVELISTENER] effect state = ", state);
	console.log("[PERSIST_SESSIONAUTOSAVELISTENER] effect session = ", session);
	console.log("[PERSIST_SESSIONAUTOSAVELISTENER] effect action = ", action);


    // Don’t save if there’s no active session/song yet

	if (!session?.id || !session?.song) {
		console.log("[AUTOSAVE] - session?.id = ", session?.id);
		console.log("[AUTOSAVE] - session?.song = ", session?.song);
		console.log("[AUTOSAVE] - returning because session?.id not defined or session?.song not defined ");
		return;
	}



	console.log("[PERSIST_SESSIONAUTOSAVELISTENER] effect session?.id = ", session?.id);
	console.log("[PERSIST_SESSIONAUTOSAVELISTENER] effect session?.song = ", session?.song);


/*
	const settings = {
	  stems: (session.stems || []).map(s => ({
		index: s.index,              // ✅ add this
		level: s.level,
		muted: !!s.muted,
		soloed: !!s.soloed,
		pan: s.pan
	  })),
	  speed: session.speed?.value ?? session.speed,   // ✅ store number
	  pitch: session.pitch?.value ?? session.pitch,   // ✅ store number
	  masterMute: !!session.masterMute,
	  updatedAt: new Date().toISOString()
	};
*/

// 🔥 IMPORTANT: read from UI-controlled values only
const stems = (session.stems || []).map(s => ({
  index: s.index,
  level: s.level,          // UI value
  muted: !!s.muted,
  soloed: !!s.soloed,
  pan: s.pan,
}));

const settings = {
  stems,
  speed: typeof session.speed === "object"
    ? session.speed.value
    : session.speed,

  pitch: typeof session.pitch === "object"
    ? session.pitch.value
    : session.pitch,

  masterMute: !!session.masterMute,
  updatedAt: new Date().toISOString(),
};




	const origin = session?.origin;


	console.log("[SAVE SETTINGS] origin", origin);
	console.log("[SAVE SETTINGS] settings summary", {
	  stems: settings.stems.map(s => ({ index: s.index, level: s.level, muted: s.muted, soloed: s.soloed, pan: s.pan })),
	  speed: settings.speed,
	  pitch: settings.pitch,
	  masterMute: settings.masterMute,
	});

	console.log("[AUTOSAVE ROUTE] deciding where to save", {
	  sessionId: session?.id,
	  origin: session?.origin,
	  songIdFromOrigin: session?.origin?.songId,
	  songIdFromSong: session?.song?.songId,
	  setlistId: session?.origin?.setlistId,
	  itemIx: session?.origin?.itemIx,
	  stemPreview: settings?.stems?.slice?.(0, 5),
	});

	console.log("[SAVE SETTINGS] origin?.type = ", origin?.type);

	if (origin?.type === "setlist") {

	  console.log("[SETLIST SAVE] entering autosave", {
		setlistId: origin.setlistId,
		itemIx: origin.itemIx,
		songId: origin.songId,
		stemsPreview: settings.stems?.map(s => ({
		  index: s.index,
		  level: s.level
		}))
	  });

	  console.log("[AUTOSAVE ROUTE] saving to SETLIST itemSettings", {
		setlistId: origin?.setlistId,
		itemIx: origin?.itemIx,
		stems: settings?.stems?.map(s => ({ index: s.index, level: s.level })),
	  });

	  listenerApi.dispatch(updateSetlistItemSettings({
		setlistId: origin.setlistId,
		itemIx: origin.itemIx,
		itemSettings: settings
	  }));

	  // 🔎 VERIFY IT LANDED IN REDUX
	  const state = listenerApi.getState();
	  const saved =
		state.setlists?.byId?.[origin.setlistId]?.items?.[origin.itemIx]?.itemSettings;

	  console.log("[SETLIST SAVE] after reducer", {
		exists: !!saved,
		savedPreview: saved?.stems?.map(s => ({
		  index: s.index,
		  level: s.level
		}))
	  });
	}
	else {
	  // default to library scope


	  const songId = origin?.songId || session.song?.songId;

	  console.log("[SAVE SETTINGS] songId resolution", {
		originSongId: origin?.songId,
		sessionSongSongId: session.song?.songId,
		sessionSongId: session.songId,
		finalSongId: songId
	  });


	  if (songId) {

		  console.log("[AUTOSAVE ROUTE] saving to LIBRARY songSettings", {
			songId,
			stems: settings?.stems?.map(s => ({ index: s.index, level: s.level })),
		  });

	  	listenerApi.dispatch(saveLibrarySongSettings({ songId, settings }));
	  }
	  else {
	  	console.log("[AUTOSAVE ROUTE] NOT saving to LIBRARY because songId not defined")
	  }

	}





	console.log("[PERSIST_SESSIONAUTOSAVELISTENER] effect p2 flushTimer = ", flushTimer);
    if (flushTimer) {
		clearTimeout(flushTimer);
	}
	console.log("[PERSIST_SESSIONAUTOSAVELISTENER] effect p3 ");
    flushTimer = setTimeout(async () => {
      try {
        console.log("[PERSIST_SESSIONAUTOSAVELISTENER] flush p1 ");
        // persistor is exported in store.js and also attached to window
        await window.__PERSISTOR__?.flush();
        console.log("[PERSIST_SESSIONAUTOSAVELISTENER] flush p2 complete (autosave)");
      } catch (e) {
        console.warn("[PERSIST_SESSIONAUTOSAVELISTENER] flush p3 failed", e);
      }
    }, 250);


	try {
		console.log("[PERSIST_SESSIONAUTOSAVELISTENER] debug before await window.__PERSISTOR__?.flush()");
		await window.__PERSISTOR__?.flush();
		console.log("[PERSIST_SESSIONAUTOSAVELISTENER] debug after await window.__PERSISTOR__?.flush()");
	} catch (e) {
	  console.warn("[PERSIST_SESSIONAUTOSAVELISTENER] debug flush failed", e);
	}


	try {
	  // 1) read the raw persisted root blob
	  const raw = await window.localforage.getItem("persist:root");
	  console.log("[PERSIST DEBUG] raw type/len", typeof raw, raw?.length);

	  // 2) parse root (redux-persist stores each slice as a JSON string)
	  const root = JSON.parse(raw);

	  // IMPORTANT: slice values are strings
	  const setlist = JSON.parse(root.setlist);

	  const sid = listenerApi.getState()?.session?.id;

	  const saved = (setlist.sessions || []).find(s => s.id === sid);

	  console.log("[PERSIST DEBUG] persisted session stems", {
		sid,
		found: !!saved,
		stems: saved?.stems?.map(s => ({ id: s.id, level: s.level, muted: s.muted, soloed: s.soloed })),
		lastUpdatedAt: saved?.lastUpdatedAt
	  });
	} catch (e) {
	  console.warn("[PERSIST DEBUG] read/parse failed", e);
	}



	try {
	  const raw = await window.localforage?.getItem?.("persist:root");
	  console.log("[PERSIST_SESSIONAUTOSAVELISTENER] raw persist:root type/len",
		typeof raw,
		raw ? ("" + raw).length : null
	  );
	  // Optional: show whether your session id appears in it (string search)
	  const sid = listenerApi.getState()?.session?.id;
	  console.log("[PERSIST_SESSIONAUTOSAVELISTENER] contains session id?", sid ? (("" + raw).includes(sid)) : "no session id");
	} catch (e) {
	  console.warn("[PERSIST_SESSIONAUTOSAVELISTENER] readback failed", e);
	}

  },
});
